<ef-loading-container
    [observables]="[postingTypes$, postingItems$]"
></ef-loading-container>
<ef-posting-account
    [accounts]="accounts"
    [items]="postingTypes$ | async"
    [postingItems]="postingItems$ | async"
    [selectedError]="selectedError"
    (ShowError)="ShowError.next($event)"
    (SaveItem)="onSavePostingType($event)"
></ef-posting-account>
